import DetailService from '../../components/DetailService';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
function KnowledgeManagement() {
    return (
        <div>
            <Header/>
        <DetailService
            titre="Knowledge Management (Gestion des connaissances)"
            categorie="Cognitique"
            image="/images/cognitique2.avif"
            description="Nous aidons les entreprises à structurer, formaliser et transmettre leurs savoirs. Nos experts, formés à la méthode MASK, vous accompagnent dans la mise en place de processus de gestion des connaissances pour assurer leur pérennité, par exemple, par le biais de livres de connaissance facilitant le partage et la capitalisation des savoirs au sein de votre organisation"
           etapes={[
            {
                numero: 1,
                titre: 'Cadrage de la mission',
                texte: 'Identification avec le client du périmètre de la mission : domaine de connaissances ciblé, acteurs concernés et objectifs de capitalisation. Cette étape définit le cadre de référence de toute l\'étude.',
            },
            {
                numero: 2,
                titre: 'Cartographie des connaissances',
                texte: 'Recensement et identification des savoirs critiques au sein de l\'organisation grâce à des entretiens avec les experts métiers. Nous distinguons les connaissances explicites (documentées) des connaissances tacites (non formalisées).',
            },
            {
                numero: 3,
                titre: 'Modélisation des processus (méthode MASK)',
                texte: 'Application de la méthode MASK pour modéliser les connaissances et les procédures identifiées sous forme de livres de connaissance structurés : diagramme de tâches, diagramme des activités, diagramme des phénomènes et diagramme des concepts.',
            },
            {
                numero: 4,
                titre: 'Validation avec les experts',
                texte: 'Relecture et validation des livrables avec les experts métiers concernés pour garantir la fidélité et l\'exhaustivité des connaissances formalisées. Les ajustements sont intégrés de manière itérative.',
            },
            {
                numero: 5,
                titre: 'Restitution et plan de déploiement',
                texte: 'Présentation finale des livrables au client avec un plan de déploiement pour intégrer les supports dans les pratiques quotidiennes des équipes et assurer la pérennité du transfert de connaissances.',
            },
        ]}
            realisations={[
               
            ]}
        />
        <Footer/>
        </div>
    );
}

export default KnowledgeManagement;
